import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  selector: 'aux-column-chooser-no-items',
  standalone: true,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
    `,
  ],
  template: `
    <div class="flex h-full flex-col items-center justify-center space-y-2 py-8 text-center">
      <aux-icon name="InfoTriangle" [size]="48" />
      <h3 class="text-2xl font-semibold text-aux-gray-darkest">No results found</h3>
      <p class="text-base">Try a different keyword or check your spelling</p>
    </div>
  `,
})
export class ColumnChooserNoItemsComponent {}
